module.exports = __webpack_public_path__ + "img/1495149537.283a3710.jpg";